import { getWizardTranslation } from "@/libs/i18n/use-wizard-translation";

import { apiErrorCode } from "./api-error-map";

/**
 * Get translated error message for a given HTTP status code
 *
 * This async function fetches the translated error message from wizard translations.
 * Falls back to the English message from apiErrorCode if translation is not available.
 *
 * **Note:** This function works on both client and server-side.
 * It uses getLocaleFromCookie() for client-side locale detection.
 *
 * @param statusCode - HTTP status code (e.g., "400", "500")
 * @returns Translated error message
 *
 * @example
 * // In a client or server component
 * const message = await getTranslatedErrorMessage("400");
 * // Returns: "Validation Failed" (English) until Spanish translations are provided
 */
export async function getTranslatedErrorMessage(
  statusCode: string
): Promise<string> {
  const key = `errors_${statusCode}`;
  const fallback = apiErrorCode[statusCode] || statusCode;

  return await getWizardTranslation(key, undefined, fallback);
}
